import { API_BASE_URL } from '@/config/api';
import { logger } from '@/lib/logger';

export type Features = {
  login: boolean;
};

const DEFAULT_FEATURES: Features = {
  login: false,
};

let _features: Features = { ...DEFAULT_FEATURES };
let _loaded = false;
let _loadError: Error | null = null;

export async function loadFeatures(): Promise<Features> {
  try {
    const response = await fetch(`${API_BASE_URL}/features`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    _features = {
      login: data.features?.login ?? false,
    };
    _loadError = null;
  } catch (err) {
    _features = { ...DEFAULT_FEATURES };
    _loadError = err instanceof Error ? err : new Error(String(err));
    logger.error(
      `Failed to load /api/v1/features from ${API_BASE_URL}. ` +
        `Falling back to defaults (login=false). Is the API running and CORS configured?`,
      { error: _loadError.message }
    );
  }
  _loaded = true;
  return _features;
}

export function getFeatures(): Features {
  return _features;
}

export function isFeatureLoaded(): boolean {
  return _loaded;
}

export function getFeaturesLoadError(): Error | null {
  return _loadError;
}
